import { render, staticRenderFns } from "./Gdtadver.vue?vue&type=template&id=2c327689&scoped=true&"
import script from "./Gdtadver.vue?vue&type=script&lang=js&"
export * from "./Gdtadver.vue?vue&type=script&lang=js&"
import style0 from "./Gdtadver.vue?vue&type=style&index=0&id=2c327689&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c327689",
  null
  
)

export default component.exports